import { render } from "./RankElementCounter.vue?vue&type=template&id=21108594&scoped=true"
import script from "./RankElementCounter.vue?vue&type=script&lang=js"
export * from "./RankElementCounter.vue?vue&type=script&lang=js"

import "./RankElementCounter.vue?vue&type=style&index=0&id=21108594&scoped=true&lang=scss"

import exportComponent from "/usr/share/nginx/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21108594"]])

export default __exports__